module.exports = __webpack_public_path__ + "img/20.a4a8b414.webp";